export default __webpack_public_path__ + "static/media/Sume_JerzyWojcik.65ee8dc0.png";